exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "what-is-soliday-euro-footer{position:relative}what-is-soliday-euro-footer label{font-size:15px!important;cursor:pointer;color:#666!important}what-is-soliday-euro-footer .amplify{color:#0072c9!important;float:right;margin-top:10px;padding-right:15px;font-size:15px;font-weight:400!important}what-is-soliday-euro-footer .more label{font-family:Stag Sans!important}what-is-soliday-euro-footer .checkbox input[type=checkbox]+label,what-is-soliday-euro-footer .checkbox input[type=checkbox]:checked+label{background-position-y:2px}what-is-soliday-euro-footer .content{padding-left:15px;padding-top:4px;height:52px;box-shadow:0 2px 4px 0 #dddfe2;border:1px solid #dddfe2;border-top:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/solidarity.module/components/whatIsSolidaryEuro/whatIsSolidayEuroFooter/whatIsSolidayEuroFooter.scss
// module id = 2269
// module chunks = 0